var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVyzerTriangleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98302 8.2002L23.0365 31.3302L19.995 36.7192L3.90002 8.2002H9.98302ZM16.066 8.2002L19.0775 13.5367H26.995L23.0365 20.5512L26.078 25.9402V25.9412L36.0905 8.2002H16.066Z",
    fill: "#0F1D2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVyzerTriangleLogo);
export default __webpack_public_path__ + "static/media/vyzer-triangle-logo.3c46ecc136624b3e82a5f04bbaf6dff0.svg";
export { ForwardRef as ReactComponent };